import React from 'react';

const HappyLoading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner" />
    </div>
  );
};

export default HappyLoading;
